import { useQuery } from '@tanstack/react-query';

import { statsApi } from '../stats.api';

import { StatsQueryParams } from './types';

export const useQueryStatsFR = ({
  dateTo,
  fromUnitType,
  fromValue,
  aircraftsIdList = [],
}: StatsQueryParams) => {
  const enabled = ![fromUnitType, fromValue, dateTo].some(v => v === undefined);
  const dateToString = dateTo.toISOString();
  return useQuery({
    queryKey: [
      'StatsFR',
      fromValue,
      fromUnitType,
      dateToString,
      aircraftsIdList,
    ],
    queryFn: async () =>
      statsApi.getFr({
        dateTo,
        fromValue,
        fromUnitType,
        aircraftsIdList,
      }),
    select: data => data,
    enabled,
  });
};
